import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';

function SectionContact() {
  return (
    <Section minHeight="70vh">
      <Block blockWidth="100%" textAlign="center" alignItems="center">
        <Typography
          intlKey="PRESS.CONTACT.TITLE"
          color="black"
          variant="title"
          gutterBottom={2}
        />

        <Typography
          gutterBottom={1}
          intlKey="PRESS.CONTACT.PRESS_EMAIL"
          variant="paragraph2"
          intlValues={{
            email: (
              <Link
                color="primary"
                href="mailto:press@nu.bank"
                typographyProps={{
                  variant: 'paragraph2',
                }}
              >
                press@nu.bank
              </Link>
            ),
          }}
        />

        <Typography
          gutterBottom={1}
          intlKey="PRESS.CONTACT.EVENTS_EMAIL"
          variant="paragraph2"
          intlValues={{
            email: (
              <Link
                color="primary"
                href="mailto:events@nubank.com.br"
                typographyProps={{
                  variant: 'paragraph2',
                }}
              >
                events@nubank.com.br
              </Link>
            ),
          }}
        />

        <Typography
          gutterBottom={1}
          intlKey="PRESS.CONTACT.CUSTOMER_EMAIL"
          variant="paragraph2"
          intlValues={{
            email: (
              <Link
                color="primary"
                href="mailto:meajuda@nubank.com.br"
                typographyProps={{
                  variant: 'paragraph2',
                }}
              >
                meajuda@nubank.com.br
              </Link>
            ),
          }}
        />

        <Typography
          intlKey="PRESS.CONTACT.MARKETING_EMAIL"
          variant="paragraph2"
          intlValues={{
            email: (
              <Link
                color="primary"
                href="mailto:marketing@nubank.com.br"
                typographyProps={{
                  variant: 'paragraph2',
                }}
              >
                marketing@nubank.com.br
              </Link>
            ),
          }}
        />
      </Block>
    </Section>
  );
}

export default React.memo(SectionContact);
